// Port of api/fuel/app/classes/filter/search/games/filters/query/play/count.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'play.count',
	priority: 61,
	require: function(config, filter) { return filter.play && rangeActive(filter.play.count, 1, 10) },
	run: function(config, filter, data, query) {
		if (filter.play.count.from > 1) query.where('p.play_players', '>=', filter.play.count.from)
		if (filter.play.count.to < 10) query.where('p.play_players', '<=', filter.play.count.to)
	}
}
